import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { URLS } from '../core/services/apiurls.constants';
import { Observable, of } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class AuthLoginService {
    getId: any;
    private jsonUrl ='assets/zipcode/zipcodes.json'

    constructor(private http: HttpClient) { }


    httpOptions = {
        headers: new HttpHeaders({
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }),
    };


    getZipcodes(): Observable<any[]> {
        return this.http.get<any[]>(this.jsonUrl);
      }

    setid(id: any) {
        sessionStorage.setItem('C_ID', id);
    }

    setlogo(hexData: any) {
        sessionStorage.setItem('C_Logo', hexData);
    }


    clientid() {
        let data = sessionStorage.getItem("C_ID");
        return data;
    }

    CLogo() {
        let logo = sessionStorage.getItem("C_Logo");
        return logo;
    }

    setportal(clientPortalID: any) {
        sessionStorage.setItem('U_ID', clientPortalID)
    }
    Token(token: any) {
        sessionStorage.setItem('TOKEN', token)
    }
    getToken() {
        let data = sessionStorage.getItem("TOKEN");
        return data;
    }
    portal_id() {
        let data = sessionStorage.getItem('U_ID');
        return data;
    }
    getDOB(dob: any) {
        sessionStorage.setItem('DOB', dob)

    }

    getCCO(cco: any) {
        sessionStorage.setItem('CCO', cco)

    }

    setCCO() {
        let data = sessionStorage.getItem("CCO")
        if (data === 'true') {
            return true;
        } else if (data === 'false') {
            return false;
        } else {

            return null;
        }
        // return data;
    }

    getMFH(mfh: any) {
        sessionStorage.setItem('MFH', mfh)
    }

    setMFH() {
        let data = sessionStorage.getItem("MFH")
        if (data === 'true') {
            return true;
        } else if (data === 'false') {
            return false;
        } else {
            return null;
        }
    }

    // New method for Secure Messaging Mode configuration
    getSecureMessagingMode(mode: string) {
        sessionStorage.setItem('SecureMessagingMode', mode);
    }

    setSecureMessagingMode(): string {
        let data = sessionStorage.getItem("SecureMessagingMode");
        // Default to 'v1' if not set
        return data || 'v1';
    }

    // Check if Secure Messaging V2 (with CC) is enabled
    isSecureMessagingV2(): boolean {
        let mode = this.setSecureMessagingMode();
        return mode.toLowerCase() === 'v2';
    }

    // Check if Secure Messaging V1 (without CC) is enabled
    isSecureMessagingV1(): boolean {
        let mode = this.setSecureMessagingMode();
        return mode.toLowerCase() === 'v1';
    }

    setDOB() {
        let data = sessionStorage.getItem("DOB")
        return data;
    }

    setGender(gender: any) {
        sessionStorage.setItem('gender', gender)

    }
    getGender() {
        let data = sessionStorage.getItem("gender")
        return data;
    }

    setname(name: any) {
        sessionStorage.setItem('C_Name', name);
    }


    clientname() {
        let data = sessionStorage.getItem("C_Name");
        return data;
    }


    setProfilePic(pic: any) {
        sessionStorage.setItem('Pic_img', pic);
    }


    ProfilePic() {
        let data = sessionStorage.getItem("Pic_img");
        return data;
    }


    availableforms(forms: any) {
        sessionStorage.setItem('Form', forms);
    }


    FormAvail() {
        let data = sessionStorage.getItem("Form");
        return data;
    }


    setClients(Totalclient: any) {
        sessionStorage.setItem('C_client', Totalclient);
    }

    getClients() {
        let data = sessionStorage.getItem("C_client")
        return data;
    }

    setClientid(Totalclientid: any) {
        sessionStorage.setItem('C_clientid', Totalclientid);
    }

    getClientid() {
        let data = sessionStorage.getItem("C_clientid")
        return data;
    }

    setPassLess(passKey: any) {
        sessionStorage.setItem('P_Less', passKey);
    }

    getPassLess() {
        let data = sessionStorage.getItem("P_Less")
        if (data === 'true' || data === 'True') {
            return true;
        } else if (data === 'false' || data === 'False') {
            return false;
        } else {

            return null;
        }
        // return data;
    }

    setOTPLess(passKey: any) {
        sessionStorage.setItem('OTP_Less', passKey);
    }

    getOTPLess() {
        let data = sessionStorage.getItem("OTP_Less")
        if ((data === 'true') || (data === 'True')){
            return true;
        } else if ((data === 'false') || (data === 'False')) {
            return false;
        } else {

            return null;
        }

    }

    packets: string = '';

    setIsFormSend(passKey: string) {
      this.packets = passKey;
    }
  
    getFormSend(): string {
      return this.packets;
    }
  
    setCC(cCode: any) {
        sessionStorage.setItem('CC', cCode);
    }

    getCC() {
        let data = sessionStorage.getItem("CC")
        return data;
    }

    setPortalVariant(variant: any) {
        sessionStorage.setItem('PortalFormVariant', variant);
    }

    getPortalVariant() {
        let data = sessionStorage.getItem("PortalFormVariant")
        return data;
    }

    setuserRegistrationTime(userRegistrationTime: any) {
        sessionStorage.setItem('userRegistrationTime', userRegistrationTime);
    }

    getuserRegistrationTime() {
        let data = sessionStorage.getItem("userRegistrationTime")
        return data;
    }

    setShowNewclientCard(Key: any) {
        sessionStorage.setItem('EnablePortalNewClientRegistration', Key);
    }
    getShowNewclientCard() {
        let data = sessionStorage.getItem("EnablePortalNewClientRegistration")
        return data;
    }

    setbase64(base64: any) {
        sessionStorage.setItem('base64', base64);
    }

    getbase64() {
        let data = sessionStorage.getItem("base64")
        return data;
    }

    setLogout(logout: any) {
        sessionStorage.setItem('logout', logout);
    }

    getLogout() {
        let data = sessionStorage.getItem("logout")
        return data;
    }

    isloggedIn: boolean = false;

    sessionLoggedIn(): any {
        return this.isloggedIn;

    }

    removeid() {
        sessionStorage.removeItem('C_ID');
        sessionStorage.removeItem('U_ID');
        sessionStorage.removeItem('C_Name');
        sessionStorage.removeItem('TOKEN');
        sessionStorage.removeItem('Pic_img');
        sessionStorage.removeItem('Form');
        sessionStorage.removeItem('DOB');
        sessionStorage.removeItem('gender');
        sessionStorage.removeItem('pass_word');
        sessionStorage.removeItem('C_Logo');
        sessionStorage.removeItem('C_client');
        sessionStorage.removeItem('C_clientid');
        sessionStorage.removeItem('P_Less');
        sessionStorage.removeItem('CCO');
        sessionStorage.removeItem('MFH');
        sessionStorage.removeItem('OTP_Less');
        sessionStorage.removeItem('AuditId')
        sessionStorage.removeItem('userRegistrationTime')
    }



    switchClients() {
        sessionStorage.removeItem('C_Name');
        sessionStorage.removeItem('C_ID');
        sessionStorage.removeItem('U_ID');
        sessionStorage.removeItem('Pic_img');
        sessionStorage.removeItem('Form');
        sessionStorage.removeItem('DOB');
        sessionStorage.removeItem('gender');
        sessionStorage.removeItem('OTP_Less');
        sessionStorage.removeItem('AuditId');
    }

    setMailId(mailId: any) {
        sessionStorage.setItem('mail_Id', mailId);
    }


    mailId() {
        let data = sessionStorage.getItem("mail_Id");
        return data;
    }
    pWord() {
        let data = sessionStorage.getItem("pass_word");
        return data;
    }

    setPword(pWord: any) {
        sessionStorage.setItem('pass_word', pWord);
    }


    Login(Access: any) {
        return this.http.post(URLS.GOBAL_URL + URLS.Profile.login, Access, this.httpOptions).pipe(
            map((res) => {
                return res;
            })
        )
    }


    isLoggedIn() {
        return !!this.clientid() && !!this.clientname && !!this.mailId
    }


    validateAllForms(Form: FormGroup) {
        const formGroup = Form;
        Object.keys(formGroup.controls).forEach((field) => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched();
            }
        });
    }


}



